module.exports = __webpack_public_path__ + "fonts/GothamSSm-Medium_Web.9604c34.woff2";